/**
 * Created by Jerker Nord on 2022-05-12.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";

export class TheBorderGPUPushView extends PIXI.Container implements StageLayer {

    private _delay:number;

    constructor() {
        super();
        this.name = "TheBorderGPUPushView";
        this._delay = 0;
    }

    public cleanup():void {
        gsap.timeline({delay : this.delay + 5}).add(() => {
            while(this.children.length > 0) {
                this.removeChildAt(0).destroy();
            }
        });
    }

    get delay():number {
        this._delay += 0.1;
        return this._delay;
    }
}